<ion-content>
  <app-header [isParentPage]="false" [title]="'Query View'"></app-header>

  <div class="loading-container" style="padding-top:15%;" *ngIf="!loaded">
    <ion-spinner></ion-spinner>
  </div>
  <div class="table-container" *ngIf="queryResult?.length > 0">
    <table class="query-table">
      <thead>
       <tr class="report-header">
            <th [attr.colspan]="columns.length" class="center-header">
              <div class="report-header-container">
                <div class="short-name">{{ webReport?.shortName || webReport?.name }}</div>
                <div class="report-date">
                  Report Date<br>
                  <span>{{ currentDate | date:'M/d/yyyy h:mm:ss a' }}</span>
                </div>
              </div>
            </th>
          </tr>
        <tr>
          <th *ngFor="let col of columns">{{ col }}</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of queryResult">
          <td *ngFor="let col of columns ; let i = index">
            <ng-container *ngIf="webReport.sumCol!='' && i== webReport.sumCol; else normalCell">
                {{ row[col] | currency:'USD':'symbol':'1.2-2' }}
              </ng-container>
              <ng-template #normalCell>
                {{ row[col] }}
              </ng-template>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="webReport.sumCol != '' && webReport.sumCol >=0 ">
        <tr class="total-row">
          <td  class="total-label"><b> Records: {{ queryResult.length }}</b></td>
        </tr>
         <tr class="total-row">
          <td [attr.colspan]="columns.length" class="total-label">Columns Totals</td>
        </tr>
         <tr class="total-row">
          <td class="total-value"><b>{{ getTotal(columns[webReport.sumCol]) | currency:'USD':'symbol':'1.2-2' }}</b></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div *ngIf="queryResult?.length === 0" class="no-data">
    <ion-text color="medium">No data found.</ion-text>
  </div>
</ion-content>
